// extracted by mini-css-extract-plugin
export default {"inputContainer":"CustomTextField_inputContainer__mWVCl","lg":"CustomTextField_lg__VeTGK","label":"CustomTextField_label__3o5wk"};